import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { SupplierVm } from './supplier.vm';
import { Type } from 'class-transformer';

export class GetSuppliersVm extends PageResponseVm<SupplierVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => SupplierVm)
  @ValidateNested({ each: true })
  objects: SupplierVm[];
}
